// extracted by mini-css-extract-plugin
export default {"draftMessage":"index_draftMessage__eCjYe"};